// Constants & Functions for sharing user data between domains throw Cookie.
// Currently used to share user-data with Promo Site

import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';
import config from '@/config';

const COOKIE_NAME = 'shared_user';
const COOKIE_PARENT_DOMAIN =
  config.release === 'development' ? 'localhost' : 'scrambleup.com';
const COOKIE_EXPIRE_DAYS = 10000000;
const COOKIE_SETTINGS = {
  expires: COOKIE_EXPIRE_DAYS,
  domain: COOKIE_PARENT_DOMAIN,
};

export const setUserToCookie = token => {
  removeUserFromCookie();
  if (!token) return null;

  const decodedData = jwtDecode(token);
  const userData = decodedData?.user ? JSON.stringify(decodedData.user) : null;
  userData && Cookies.set(COOKIE_NAME, userData, COOKIE_SETTINGS);
};

export const removeUserFromCookie = () => {
  Cookies.remove(COOKIE_NAME);
};